import React, { useState, useEffect } from 'react';
import '../styles/HomePage.css';
import { Tooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';

import rabbit from '../assets/rabbit.png';
import imessage from '../assets/imessage_logo.png';
import linkedin from '../assets/linkedin_logo.png';
import github from '../assets/github_logo.png';
import terminal from '../assets/terminal_logo.png';
import trash from '../assets/trash_logo.png';
import dark from '../assets/dark.png';
import darkHover from '../assets/dark-hover.png';
import light from '../assets/light.png';
import lightHover from '../assets/light-hover.png';
import help from '../assets/help.png';

import Background from '../components/Background.jsx';
import Window from '../components/Window.jsx';
import AboutMe from '../components/AboutMe.jsx';
import Expertise from '../components/Expertise.jsx';
import Projects from '../components/Projects.jsx';
import Contact from '../components/Contact.jsx';
import Help from '../components/Help.jsx';

const HomePage = () => {
    const navigate = useNavigate();
    const [currentTime, setCurrentTime] = useState(new Date());
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    const [isDarkMode, setIsDarkMode] = useState(darkThemeMq.matches);

    const [activeWindows, setActiveWindows] = useState({
        aboutMe: false,
        expertise: false,
        projects: false,
        contact: false,
        help: false,
    });
    const [minimisedWindows, setMinimisedWindows] = useState({
        aboutMe: false,
        expertise: false,
        projects: false,
        contact: false,
        help: false,
    })
    const [maximisedWindows, setMaximisedWindows] = useState({
        aboutMe: false,
        expertise: false,
        projects: false,
        contact: false,
        help: false,
    })
    const [dockItems, setDockItems] = useState([]);
    const [zIndexMap, setZIndexMap] = useState({}); // Track z-index for each window
    const [currentZIndex, setCurrentZIndex] = useState(10); // Initial z-index

    // Update time every second
    useEffect(() => {
        const timer= setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formattedTime = `${currentTime.toLocaleString('en-US', { weekday: 'short' })} 
                           ${currentTime.getDate()}
                           ${currentTime.toLocaleString('en-US', { month: 'short' })}
                           ${currentTime.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;

                           
    // Function to toggle dark/light mode
    const toggleTheme = () => {
        setIsDarkMode(!isDarkMode); // Toggle the mode
    };

    // Function to handle opening a window
    const openWindow = (windowName) => {
        setActiveWindows((prev) => ({ ...prev, [windowName]: true }));
        setMinimisedWindows((prev) => ({...prev, [windowName]: false}));

        // Add to dock if not already open
        if (windowName !== 'contact' && !dockItems.includes(windowName)) {
            setDockItems([...dockItems, windowName]);
        }

        // Update z-index for the newly opened window
        setZIndexMap((prev) => ({
            ...prev,
            [windowName]: currentZIndex
        }));
        setCurrentZIndex(currentZIndex + 1); // Increment z-index for the next window

        console.log(zIndexMap[windowName])
    };

    // Function to handle closing a window
    const closeWindow = (windowName) => {
        setActiveWindows((prev) => ({ ...prev, [windowName]: false }));
        setDockItems(dockItems.filter((item) => item !== windowName));
    };

    // Function to close all windows (triggered by Home link)
    const closeAllWindows = () => {
        setActiveWindows({
            aboutMe: false,
            expertise: false,
            projects: false,
            contact: false,
            help: false,
        });
        setDockItems([]);
    };

    const minimiseWindow = (windowName) => {
        setMinimisedWindows((prev) => ({...prev, [windowName]: true}));
    }

    const maximiseWindow = (windowName) => {
        setMaximisedWindows((prev) => ({...prev, [windowName]: !maximisedWindows[windowName]}));
    }

    const windowConfigs = [
        {
            name: 'aboutMe',
            heading: 'About Me',
            content: <AboutMe isDarkMode={isDarkMode} />,
        },
        {
            name: 'expertise',
            heading: 'Expertise',
            content: <Expertise isDarkMode={isDarkMode} />,
        },
        {
            name: 'projects',
            heading: 'Projects',
            content: <Projects isDarkMode={isDarkMode} />,
        },
        {
            name: 'contact',
            heading: 'Contact',
            content: <Contact isDarkMode={isDarkMode} />,
        },
        {
            name: 'help',
            heading: 'Help',
            content: <Help isDarkMode={isDarkMode} />,
        },
    ];

    const getTooltipContent = (item) => {
        switch (item) {
            case 'aboutMe':
                return 'About Me'
            case 'expertise':
                return 'Expertise';
            case 'projects':
                return 'Projects';
            case 'help':
                return 'Help';
            default:
                return item;
        }
    };

    return (
        <div>
            <Background />
            {/* Navigation Bar */}
            <div className={`navbar ${isDarkMode ? 'navbar-dark' : 'navbar-light'}`}>
                <div className="left-nav">
                    <div className="nav-logo" onClick={() => navigate('/login')}>CSHEN.</div>
                    <div className={`nav-link nav-home`} onClick={closeAllWindows}>Home</div>
                    <div className="nav-link" onClick={() => openWindow('aboutMe')}>About Me</div>
                    <div className="nav-link" onClick={() => openWindow('expertise')}>Expertise</div>
                    <div className="nav-link" onClick={() => openWindow('projects')}>Projects</div>
                    <div className="nav-link" onClick={() => openWindow('contact')}>Contact</div>
                    <div className="nav-link" onClick={() => openWindow('help')}>Help</div>
                </div>
                <div className="right-nav">
                    <div className="theme" onClick={toggleTheme}>
                        <img 
                            src={isDarkMode ? dark : light}
                            onMouseEnter={(e) => (e.currentTarget.src = isDarkMode ? darkHover : lightHover)} 
                            onMouseLeave={(e) => (e.currentTarget.src = isDarkMode ? dark : light)} 
                            alt="theme toggle" 
                        />
                    </div>
                    <div className="time">
                        {formattedTime}
                    </div>
                </div>
            </div>

            {/* Bunny Icons for Desktop */}
            <div className="desktop">
                <div className="icon-item" onClick={() => openWindow('aboutMe')}>
                    <img src={rabbit} alt="About Me Icon Rabbit" />
                    <p>About Me</p>
                </div>
                <div className="icon-item" onClick={() => openWindow('expertise')}>
                    <img src={rabbit} alt="Expertise Icon Rabbit" />
                    <p>Expertise</p>
                </div>
                <div className="icon-item" onClick={() => openWindow('projects')}>
                    <img src={rabbit} alt="Projects Icon Rabbit" />
                    <p>Projects</p>
                </div>
                <div className={`icon-item desktop-hide`} onClick={() => openWindow('help')}>
                    <img src={help} alt="Help Guide Icon" />
                    <p>Help</p>
                </div>
            </div>

            {/* Dock with Social Links */}
            <div className={`dock ${isDarkMode ? 'dock-dark' : 'dock-light'}`}>
                <a href="https://www.linkedin.com/in/celina-shen" target="_blank" rel="noopener noreferrer">
                    <img src={linkedin} alt="LinkedIn Icon"
                        data-tooltip-id="linkedin"
                        data-tooltip-content="Linked In"
                        data-tooltip-place="top"
                    />
                </a>
                <Tooltip id="linkedin" className={`dock-tooltip ${isDarkMode ? 'tooltip-dark' : 'tooltip-light'}`}/>
                <a href="https://github.com/cshenn" target="_blank" rel="noopener noreferrer">
                    <img
                        src={github}
                        alt="GitHub Icon"
                        data-tooltip-id="github"
                        data-tooltip-content="GitHub"
                        data-tooltip-place="top"
                    />
                </a>
                <Tooltip id="github" className={`dock-tooltip ${isDarkMode ? 'tooltip-dark' : 'tooltip-light'}`}/>
                <img 
                    src={imessage} alt="iMessage Icon"
                    data-tooltip-id="contact"
                    data-tooltip-content="Contact Me"
                    data-tooltip-place="top"
                    onClick={() => openWindow('contact')}
                />
                <Tooltip id="contact" className={`dock-tooltip ${isDarkMode ? 'tooltip-dark' : 'tooltip-light'}`}/>

                <div className="dock-division" />
                
                <img
                    src={terminal}
                    alt="Terminal Icon"
                    className="dock-hide"
                    data-tooltip-id="terminal"
                    data-tooltip-content="Terminal"
                    data-tooltip-place="top"
                />
                <Tooltip id="terminal" className={`dock-tooltip ${isDarkMode ? 'tooltip-dark' : 'tooltip-light'}`}/>
                <img
                    src={trash}
                    alt="Rubbish Bin Icon"
                    className="dock-hide"
                    data-tooltip-id="bin"
                    data-tooltip-content="Bin"
                    data-tooltip-place="top"
                />
                <Tooltip id="bin" className={`dock-tooltip ${isDarkMode ? 'tooltip-dark' : 'tooltip-light'}`}/>

                {dockItems.map((item, index) => (
                    <div key={index} className="dock-item" onClick={() => openWindow(item)}>
                        <img
                        data-tooltip-id={item}
                        data-tooltip-content={getTooltipContent(item)}
                        data-tooltip-place="top"
                        src={rabbit}
                        alt={`${item} icon`}
                        className="dock-hide"/>
                        <Tooltip id={item} className={`dock-tooltip ${isDarkMode ? 'tooltip-dark' : 'tooltip-light'}`}/>
                    </div>
                ))}
            </div>

            {windowConfigs.map(({ name, heading, content }) => {
                if (!activeWindows[name]) return null;

                return (
                    <Window
                        key={name}
                        isDarkMode={isDarkMode}
                        heading={heading}
                        content={content}
                        onClose={() => closeWindow(name)}
                        onMinimise={() => minimiseWindow(name)}
                        isMinimised={minimisedWindows[name]}
                        onMaximise={() => maximiseWindow(name)}
                        isMaximised={maximisedWindows[name]}
                        style={{ zIndex: zIndexMap[name] }} // Apply z-index dynamically
                    />
                );
            })}
        </div>
    );
};

export default HomePage;